import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { TGrupoMinisterio } from "../../../../types";

interface GetMembrosProps {

}

type ResponseMembrosCheckin = {
  listAll: TGrupoMinisterio[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: TGrupoMinisterio[]
  pagina: number
}

const GetGrupoMinisterio = (): ResponseMembrosCheckin => {

  const [listSedes, setListSedes] = useState<TGrupoMinisterio[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<TGrupoMinisterio[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<TGrupoMinisterio[]>('ministerio/grupo', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {

          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<TGrupoMinisterio[]>('ministerio/grupo')
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {

          console.log(error?.response);
        }
      )
  }, [ resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listSedes,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams
  };
}

export default GetGrupoMinisterio;
